import React, { useState, useEffect } from "react";
import { useWeb3React } from "@web3-react/core";
import { ethers } from "ethers";
import moment from "moment";
import ClipLoader from "react-spinners/ClipLoader";

import {
  Card,
  Image,
  Tooltip,
  Modal,
  Badge,
  Alert,
  Spin,
  Button,
  Select,
} from "antd";

import Slider from "react-slick";
import author_1 from "../img/authors/author-1.png";

import AuctionContractJSON from "../contracts/Auction.json";
import AuctionManagerContractJSON from "../contracts/AuctionManager.json";
import SafeMarsNFTContractJSON from "../contracts/SafeMarsNFT.json";
import MarketplaceContractJSON from "../contracts/Marketplace.json";

const styles = {
  NFTs: {
    display: "flex",
    flexWrap: "wrap",
    WebkitBoxPack: "start",
    justifyContent: "flex-start",
    margin: "0 auto",
    maxWidth: "1000px",
    gap: "10px",
  },
  banner: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    margin: "0 auto",
    width: "600px",
    //borderRadius: "10px",
    height: "150px",
    marginBottom: "40px",
    paddingBottom: "20px",
    borderBottom: "solid 1px #e3e3e3",
  },
  logo: {
    height: "115px",
    width: "115px",
    borderRadius: "50%",
    // positon: "relative",
    // marginTop: "-80px",
    border: "solid 4px white",
  },
  text: {
    color: "#041836",
    fontSize: "27px",
    fontWeight: "bold",
  },
};

function NFTTokenIds({ web3 }) {
  const { account, library } = useWeb3React();
  const [auctions, setAuctions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(true);
  const [displayAuctions, setDisplayAuctions] = useState([]);
  const [listings, setListings] = useState([]);
  const [displayListings, setDisplayListings] = useState([]);
  const [listingCount, setListingCount] = useState(0);
  const [auctionCount, setAuctionCount] = useState(0);

  const MAX_DISPLAY_COUNT = 4;

  const { Option } = Select;
  const fallbackImg =
    "data:image/png;base64,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";

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(async () => {
    setListings([]);
    getListedNfts();
  }, [setListings]);

  useEffect(async () => {
    setAuctions([]);
    getAuctions();
  }, [setAuctions]);

  const getListedNfts = async () => {
    const marketplaceContract = new web3.eth.Contract(
      MarketplaceContractJSON.abi,
      process.env.REACT_APP_MARKET_PLACE
    );

    const safeMarsNFTContract = new web3.eth.Contract(
      SafeMarsNFTContractJSON.abi,
      process.env.REACT_APP_SAFEMARS_NFT
    );
    try {
      const listedNfts = await marketplaceContract.methods
        .getListedNfts()
        .call();

      let count = 0;

      if (listedNfts.length > 0) {
        for (const list of listedNfts) {
          if (list.seller == 0) continue;

          ++count;
          const tokenUri = await safeMarsNFTContract.methods
            .tokenURI(parseInt(list.tokenId))
            .call();

          const listing = await fetch(tokenUri);
          const data = await listing.json();

          if (data) {
            data.tokenId = +list.tokenId;
            data.price = +list.price / 1e18;
            data.startPrice = data.price;
            data.isOwner = list.seller === account;
            data.owner = list.seller;
            data.timestamp = moment(list.timestamp * 1000).fromNow() ?? "";
            data.created = data.timestamp;

            if (data.animation_type) {
              data.media_type = data.animation_type.split("/")[0];
            }

            setListings((oldArray) => {
              const newArray = [...oldArray];
              newArray.push(data);
              return newArray;
            });

            setDisplayListings((oldArray) => {
              const newArray = [...oldArray];
              newArray.push(data);
              return newArray;
            });
          }

          //console.log(data);
        }
      }

      setListingCount(count);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const getAuctions = async () => {
    const auctionManagerContract = new web3.eth.Contract(
      AuctionManagerContractJSON.abi,
      process.env.REACT_APP_AUCTION_MANAGER
    );

    const safeMarsNFTContract = new web3.eth.Contract(
      SafeMarsNFTContractJSON.abi,
      process.env.REACT_APP_SAFEMARS_NFT
    );
    try {
      const auctionAddresses = await auctionManagerContract.methods
        .getAuctions()
        .call();

      const auctions = await auctionManagerContract.methods
        .getAuctionInfo(auctionAddresses)
        .call();
      let availableAuctions = 0;
      for (let i = 0; i < auctions.endTime.length; i++) {
        if (+auctions.auctionState[i] === 0) {
          ++availableAuctions;
        }
      }

      for (let i = 0; i < auctions.endTime.length; i++) {
        const auctionAddress = auctions.auctionAddress[i];
        const endTime = auctions.endTime[i];
        const tokenId = auctions.tokenIds[i];
        const buyerWithdrawn = auctions.buyerWithdrawn[i];
        const bidderWithdrawn = auctions.bidderWithdrawn[i];
        const auctionState = +auctions.auctionState[i];
        const startPrice = ethers.utils.formatEther(auctions.startPrice[i]);
        const directBuyPrice = ethers.utils.formatEther(auctions.directBuy[i]);
        const highestBidder = auctions.highestBidder[i];
        const highestBid = ethers.utils.formatEther(auctions.highestBid[i]);
        const address = auctionAddresses[i];
        const owner = auctions.owner[i];
        const timestamp = auctions.startTime[i];

        let state = "";
        if (auctionState === 0) {
          state = "Open";
        }
        if (auctionState === 1) {
          state = "Cancelled";
        }
        if (auctionState === 2) {
          state = "Ended";
        }
        if (auctionState === 3) {
          state = "Direct Buy";
        }

        const tokenUri = await safeMarsNFTContract.methods
          .tokenURI(parseInt(tokenId))
          .call();

        const listing = await fetch(tokenUri);

        const resp = await listing.json();

        resp.dateTime = resp.attributes[1].value;

        const from = moment(new Date());
        const to = moment.utc(1000 * endTime);

        const duration = moment.duration(to.diff(from));

        let days = duration.days();
        let hours = duration.hours();
        let minutes = duration.minutes();
        let seconds = duration.seconds();
        let stopBid = false;
        let isAuctionEnded =
          state === "Ended" || state === "Direct Buy" || state === "Cancelled";

        if (isAuctionEnded || seconds <= 0) {
          days = 0;
          hours = 0;
          minutes = 0;
          seconds = 0;
          stopBid = true;
        }

        const isOwner = owner === account;

        const showCancelAuction = isOwner && !isAuctionEnded && highestBid <= 0;

        let showWithdrawFund = false;
        let showWithdrawToken = false;

        if (isAuctionEnded && isOwner && highestBidder !== account) {
          showWithdrawFund = true;
          showWithdrawToken = false;
        } else if (isAuctionEnded && highestBidder === account && !isOwner) {
          showWithdrawFund = false;
          showWithdrawToken = true;
        } else {
          showWithdrawFund = false;
          showWithdrawToken = false;
        }

        let data = {
          address,
          auctionAddress,
          highestBidder,
          buyerWithdrawn,
          bidderWithdrawn,
          endTime,
          stopBid,
          startPrice,
          created: moment(resp.dateTime).format("MM/DD/yyyy, h:mm:ss a") ?? "",
          owner,
          isOwner,
          directBuyPrice,
          tokenId,
          highestBid,
          auctionState: state,
          name: resp.name,
          description: resp.description,
          date: {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds,
          },
          timestamp: moment(timestamp * 1000).fromNow() ?? "",
          auctionEnded: isAuctionEnded,
          showWithdrawFund,
          showWithdrawToken,
          showCancelAuction,
          isAuctionEnded,
        };

        if (resp.image) data.image = resp.image;
        if (resp.animation_url) data.animation_url = resp.animation_url;
        if (resp.animation_type) {
          data.animation_type = resp.animation_type;
          data.media_type = data.animation_type.split("/")[0];
        }

        setAuctions((oldArray) => {
          const newArray = [...oldArray];
          newArray.push(data);

          return newArray;
        });
        if (data.auctionState === "Open") {
          setDisplayAuctions((oldArray) => {
            const newArray = [...oldArray];
            newArray.push(data);

            return newArray;
          });
        }
      }
      setAuctionCount(availableAuctions);
    } catch (err) {
      console.log(err);
    }

    setLoading1(false);
  };

  const showItem = (data, type) => {
    localStorage.setItem("nftData", JSON.stringify(data));
    localStorage.setItem("type", type);
    window.location = "/item";
  };

  return (
    <>
      <section className="hero bg-dark py-5">
        <div id="particles-js"></div>
        <div className="container z-index-20 position-relative ">
          <div className="row align-items-center mt-5">
            <div className="col-lg-12 text-center">
              <h1 className="white_color">SafeMars NFT Marketplace</h1>
              <p className="text-muted max-w-80">
                Buy, sell and trade NFT's in our Marketplace. Auction your NFT's
                to the highest bidder and keep track of your earnings! The
                SafeMars NFT Marketplace.
              </p>

              <div class="col-12">
                <div class="row">
                  <div class="align-items-center stas-home col-12">
                    <div class="row">
                      {/* <div class="col-sm-4 text-center">
                        <p class="h1 mb-0 white-color">102</p>
                        <span class="text-muted">Collectibles</span>
                      </div> */}
                      <div class="col-sm-6 text-center">
                        <p class="h1 mb-0 white-color">{listingCount}</p>
                        <span class="text-muted">MarketPlace</span>
                      </div>
                      <div class="col-sm-6 text-center">
                        <p class="h1 mb-0 white-color">{auctionCount}</p>
                        <span class="text-muted">Auctions</span>
                      </div>
                      {/* <div class="col-sm-4 text-center">
                        <p class="h1 mb-0 white-color">420</p>
                        <span class="text-muted">NFT</span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <a className="btn btn-gradient-primary mt-4" href="explore-3">
                Explore{" "}
              </a> */}
            </div>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <header className="mb-2">
            <div className="row">
              <div className="col-lg-12 text-center">
                <h2 className="section_margin white_color no-padding-bottom">
                  New items
                </h2>
                <p className="text-muted text-sm mb-0">
                  Find the latest NFT's in the SafeMars NFT Marketplace!
                </p>
              </div>
            </div>
          </header>

          {/* ????? */}
          <div style={styles.NFTs}>
            <div className="d-flex justify-content-center w-100">
              <ClipLoader
                color={"#ffffff"}
                loading={loading}
                size={80}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
            <span
              className={displayListings.length === 0 ? "m-auto" : "d-none"}
            >
              No Item to display
            </span>

            {displayListings.map(function (data, i) {
              return (
                <Slider {...settings} className="container">
                  <Card
                    hoverable
                    cover={
                      <div className="swiper-slide p-2">
                        <div
                          className="card rounded shadow-sm card-hover-image "
                          style={{ width: "330px" }}
                        >
                          <div className="card-body p-3 position-relative">
                            <div className="position-relative mb-4 shadow">
                              <div className="card-img-holder rounded overflow-hidden">
                                {data.image && (
                                  <img
                                    class="img-fluid rounded w-100"
                                    src={data.image}
                                    alt=""
                                  />
                                )}

                                {data.media_type &&
                                  data.media_type === "video" && (
                                    <video
                                      width="320"
                                      height="240"
                                      controlsList="nodownload"
                                      controls
                                    >
                                      <source
                                        src={data.animation_url}
                                        type={data.animation_type}
                                      />
                                      Your browser does not support the video
                                      element.
                                    </video>
                                  )}

                                {data.media_type &&
                                  data.media_type === "audio" && (
                                    <audio controlsList="nodownload" controls>
                                      <source
                                        src={data.animation_url}
                                        type={data.animation_type}
                                      />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                  )}
                              </div>
                            </div>
                            <div className="fw-bold mb-3">
                              {/* <Meta title={nft.name} /> */}
                              {data.name}
                            </div>

                            <p class="text-sm text-muted fw-normal mb-2 d-flex align-items-center">
                              <span class="icon bg-primary text-white me-2">
                                <i class="lab la-bitcoin fa-fw"></i>
                              </span>
                              <span>Price: </span>
                              <span className="text-primary ms-2">
                                {" "}
                                {data.price}{" "}
                                {process.env.REACT_APP_TOKEN_SYMBOL}
                              </span>
                              {/* <span class="ms-2">1/20</span> */}
                            </p>

                            <div className="my-3 pt-1 bg-body rounded-pill"></div>

                            <ul class="list-unstyled d-flex align-items-center justify-content-between fw-normal text-sm text-muted mb-0">
                              <li class="d-flex align-items-center">
                                <i class="la-sm text-primary las la-clock me-2 text-primary"></i>
                                {data.timestamp}
                              </li>
                            </ul>

                            <button
                              onClick={() => showItem(data, 1)}
                              class="btn btn-primary btn-sm w-100 mt-4"
                            >
                              View Item
                            </button>
                          </div>
                        </div>
                      </div>
                    }
                    // key={index}
                    // onClick={() => {
                    //   setInputValue(nft?.addrs);
                    //   setImageURL(nft?.image);
                    //   setCollectionName(nft?.name);
                    // }}
                  ></Card>
                </Slider>
              );
            })}
            {/* {inputValue !== "explore" && (
              <Slider {...settings} className="container">
                {sortedNFTTokenIds.slice(0, 20).map((nft, index) => (
                  <Card
                    hoverable
                    cover={
                      <div className="swiper-slide p-2">
                        <div className="card rounded shadow-sm card-hover-image">
                          <div
                            className="card-body p-3 position-relative"
                            style={{ paddingTop: "0px" }}
                          >
                            <div className="marketplace_price min_height_price">
                              {getMarketItem(nft) && (
                                <Badge.Ribbon
                                  text={
                                    getMarketItem(nft).price / ("1e" + 9) +
                                    " (SAFEMARS)"
                                  }
                                ></Badge.Ribbon>
                              )}
                            </div>
                            <div className="position-relative mb-4 shadow">
                              <div className="card-img-holder rounded overflow-hidden">
                                {(() => {
                                  if (nft.fileType === "video") {
                                    return (
                                      <video
                                        width="100%"
                                        height="100%"
                                        controls
                                      >
                                        <source
                                          src={nft.image}
                                          type={nft.file}
                                        />
                                      </video>
                                    );
                                  } else if (nft.fileType === "image") {
                                    return (
                                      <Image
                                        preview={false}
                                        src={nft?.image || "error"}
                                        fallback={fallbackImg}
                                        alt=""
                                      />
                                    );
                                  } else if (nft.fileType === "audio") {
                                    return (
                                      <audio controls>
                                        <source
                                          src={nft.image}
                                          type={nft.file}
                                        />
                                      </audio>
                                    );
                                  }
                                })()}
                              </div>
                            </div>
                            <div className="fw-bold mb-3">
                              <Meta
                                title={nft.name}
                                description={`#${nft.token_id}`}
                              />
                            </div>
                            <div className="my-3 pt-1 bg-body rounded-pill"></div>
                            <div className="row nft_cards">
                              <div
                                className="col-md-12"
                                style={{ minHeight: "30px" }}
                              >
                                <Tooltip title="Buy NFT">
                                  {getMarketItem(nft) && (
                                    <a
                                      href={() => false}
                                      className="btn btn-gradient-primary buy_now_button col-12"
                                      onClick={() => handleBuyClick(nft)}
                                    >
                                      Buy Now
                                    </a>
                                  )}
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    key={index}
                    onClick={() => handleBuyClick(nft)}
                  ></Card>
                ))}
              </Slider>
            )} */}
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container py-5">
          <header className="mb-5">
            <div className="row">
              <div className="col-lg-12 text-center">
                <h2 className="white_color">Live Auctions</h2>
                <p className="text-muted text-sm mb-0">
                  Bid on NFT's from your favorite artist!, Video, Music, Meme's
                </p>
              </div>
            </div>
          </header>

          <div style={styles.NFTs}>
            <div className="d-flex justify-content-center w-100">
              <ClipLoader
                color={"#ffffff"}
                loading={loading1}
                size={80}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
            <span
              className={displayAuctions.length === 0 ? "m-auto" : "d-none"}
            >
              No Item to display
            </span>

            <Slider {...settings} className="container">
              {/* ???? */}
              {displayAuctions.map(function (data, i) {
                return (
                  <div className="swiper-slide p-2">
                    <div
                      className="card rounded shadow-sm"
                      style={{ width: "330px" }}
                    >
                      <div className="card-body p-3 position-relative">
                        <div className="position-relative mb-4 shadow">
                          <div className="author z-index-20">
                            <img
                              className="img-fluid rounded-circle"
                              src={author_1}
                              alt="..."
                              width="45"
                            />
                            <span className="icon bg-primary text-white">
                              <i className="las la-check-double"></i>
                            </span>
                          </div>

                          <div className="card-img-holder rounded overflow-hidden">
                            {data.image && (
                              <img
                                class="img-fluid rounded w-100"
                                src={data.image}
                                alt=""
                              />
                            )}

                            {data.media_type && data.media_type === "video" && (
                              <video
                                width="320"
                                height="240"
                                controlsList="nodownload"
                                controls
                              >
                                <source
                                  src={data.animation_url}
                                  type={data.animation_type}
                                />
                                Your browser does not support the video element.
                              </video>
                            )}

                            {data.media_type && data.media_type === "audio" && (
                              <audio controlsList="nodownload" controls>
                                <source
                                  src={data.animation_url}
                                  type={data.animation_type}
                                />
                                Your browser does not support the audio element.
                              </audio>
                            )}
                          </div>
                        </div>

                        <p className="fw-bold mb-3">
                          <a className="white-color" href="item">
                            {data.name}
                          </a>
                        </p>

                        <p class="text-sm text-muted fw-normal mb-2 d-flex align-items-center">
                          <span class="icon bg-primary text-white me-2">
                            <i class="lab la-bitcoin fa-fw"></i>
                          </span>
                          <span>Start Price: </span>
                          <span class="text-primary ms-2">
                            {data.startPrice}{" "}
                            {process.env.REACT_APP_TOKEN_SYMBOL}
                          </span>
                        </p>
                        <p class="text-sm text-muted fw-normal mb-2 d-flex align-items-center">
                          <span class="icon bg-primary text-white me-2">
                            <i class="lab la-bitcoin fa-fw"></i>
                          </span>
                          <span>Direct Buy: </span>
                          <span class="text-primary ms-2">
                            {data.directBuyPrice}{" "}
                            {process.env.REACT_APP_TOKEN_SYMBOL}
                          </span>
                        </p>
                        <p class="text-sm text-muted fw-normal mb-2 d-flex align-items-center">
                          <span class="icon bg-primary text-white me-2">
                            <i class="lab la-bitcoin fa-fw"></i>
                          </span>
                          <span>Highest Bid: </span>
                          <span class="text-primary ms-2">
                            {data.highestBid}{" "}
                            {process.env.REACT_APP_TOKEN_SYMBOL}
                          </span>
                        </p>
                        <p class="text-sm text-muted fw-normal mb-2 d-flex align-items-center">
                          <span class="icon bg-primary text-white me-2">
                            <i class="lab la-bitcoin fa-fw"></i>
                          </span>
                          <span>Auction State: </span>
                          <span class="text-primary ms-2">
                            {data.auctionState}
                          </span>
                        </p>

                        <div
                          class="p-2 counter d-flex align-items-center justify-content-center text-center counter-1"
                          data-date="14-12-2021"
                          data-time="12:00"
                        >
                          <div class="day counter-item">
                            <strong class="num">{data.date.days}</strong>
                            <small class="small word">Days</small>
                          </div>
                          <div class="hour counter-item">
                            <strong class="num">{data.date.hours}</strong>
                            <small class="small word">Hours</small>
                          </div>
                          <div class="min counter-item">
                            <strong class="num">{data.date.minutes}</strong>
                            <small class="small word">Minutes</small>
                          </div>
                          <div class="sec counter-item">
                            <strong class="num">{data.date.seconds}</strong>
                            <small class="small word">Seconds</small>
                          </div>
                        </div>

                        <div className="my-3 pt-1 bg-body rounded-pill"></div>
                        <span style={{ color: "#fff" }}>{data.timestamp}</span>
                        <button
                          onClick={() => showItem(data, 2)}
                          class="btn btn-primary btn-sm w-100 mt-4"
                        >
                          View Auction
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
      </section>

      <div className="scroll-top-btn d-flex align-items-center shadow">
        <span>Top</span>
        <i className="las la-arrow-right ms-2"></i>
      </div>
    </>
  );
}

export default NFTTokenIds;
